/**
 * 封装一下Map的set,get,clear等操作，以便后续进行扩展
 */
class DataMap extends Map {
  constructor() {
    super();
    ['set', 'get', 'delete', 'clear', 'has'].forEach(val => {
      this[val] = this[val].bind(this);
    })
  }
  set(key, value) {
    super.set(key, value);
  }
  get(key) {
    return super.get(key);
  }
  delete(key) {
    super.delete(key);
  }
  clear() {
    super.clear();
  }
  has(key) {
    return super.has(key);
  }
}
export default DataMap;